(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["announcement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-ann-timer')) {
    const SECOND = 1000;
    const pad2 = (value) => String(value).padStart(2, '0');

    customElements.define(
      'sx-ann-timer',
      class extends HTMLElement {
        connectedCallback() {
          this.end = new Date(this.dataset.end).getTime();
          if (Number.isNaN(this.end)) {
            this.hidden = true;
            return;
          }
          this.units = {};
          this.querySelectorAll('[data-unit]').forEach((el) => {
            this.units[el.dataset.unit] = el;
          });
          this.tick();
          this.timer = window.setInterval(() => this.tick(), SECOND);
        }

        disconnectedCallback() {
          window.clearInterval(this.timer);
        }

        tick() {
          const left = this.end - Date.now();
          if (left <= 0) {
            window.clearInterval(this.timer);
            this.hidden = true;
            return;
          }
          const parts = {
            days: Math.floor(left / 86400000),
            hours: Math.floor((left / 3600000) % 24),
            minutes: Math.floor((left / 60000) % 60),
            seconds: Math.floor((left / SECOND) % 60),
          };
          Object.entries(parts).forEach(([unit, value]) => {
            const el = this.units[unit];
            if (!el) return;
            if (unit === 'days') el.hidden = value === 0;
            el.querySelector('.sx-countdown__value').textContent = pad2(value);
          });
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-buy-buttons')) {
    customElements.define(
      'sx-buy-buttons',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          const data = this.dataset;
          this.sectionId = data.sectionId;
          this.productId = data.productId;
          this.form = document.getElementById(data.formId);
          this.actions = this.querySelector('[data-buy-actions]');
          this.soldOutPanel = this.querySelector('[data-buy-soldout]');
          this.errorEl = this.querySelector('[data-buy-error]');
          this.atc = this.querySelector('[data-buy-atc]');
          this.buyNow = this.querySelector('[data-buy-now]');
          this.payment = this.querySelector('[data-buy-payment]');
          this.qtyInput = this.querySelector('input[name="quantity"]');
          this.modal = this.querySelector('[data-quick-buy]');
          this.sticky = this.querySelector('[data-sticky-buy]');
          this.state = data.soldOut === 'true' ? 'sold-out' : data.available === 'true' ? 'available' : 'unavailable';

          this.atc?.addEventListener('click', () => this.add('cart', this.atc));
          this.buyNow?.addEventListener('click', () => this.add('checkout', this.buyNow));
          this.form?.addEventListener('submit', (event) => {
            event.preventDefault();
            this.add('cart', this.atc);
          });
          this.qtyInput?.addEventListener('change', () => this.syncQuantity(this.qtyInput.value, 'main'));

          this.setupQuickBuy();
          this.setupSticky();

          this.onQuantity = (event) => {
            const detail = event.detail || {};
            if (detail.productId && detail.productId !== String(this.productId)) return;
            this.syncQuantity(detail.quantity);
          };
          this.onVariant = (event) => {
            const detail = event.detail || {};
            if (detail.sectionId !== this.sectionId) return;
            const variant = detail.variant;
            this.setState(!variant ? 'unavailable' : variant.available ? 'available' : 'sold-out');
          };
          document.addEventListener(this.eventName('quantity', 'sx:pdp-quantity'), this.onQuantity);
          document.addEventListener(this.eventName('variantChanged', 'sx:variant-changed'), this.onVariant);

          const published = window.__sxPdpQuantity;
          if (published && published.productId === String(this.productId)) this.syncQuantity(published.quantity);

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.syncPaymentButton(), { once: true });
          } else {
            requestAnimationFrame(() => this.syncPaymentButton());
          }
        }

        disconnectedCallback() {
          document.removeEventListener(this.eventName('quantity', 'sx:pdp-quantity'), this.onQuantity);
          document.removeEventListener(this.eventName('variantChanged', 'sx:variant-changed'), this.onVariant);
          this.observer?.disconnect();
          this.sticky?.remove();
          this.bound = false;
        }

        eventName(key, fallback) {
          return window.SxTheme?.events?.[key] || fallback;
        }

        get quantity() {
          return Math.max(1, parseInt(this.qtyInput?.value, 10) || 1);
        }

        get hasChoices() {
          return this.dataset.hasChoices === 'true' || this.personalizationCount() > 0;
        }

        personalizationCount() {
          return document.querySelectorAll(`sx-personalization[data-section-id="${this.sectionId}"]`).length;
        }

        syncQuantity(value, source) {
          const quantity = Math.max(1, Math.floor(Number(value) || 1));
          const apply = (input) => {
            if (!input) return;
            const stepper = input.closest('sx-quantity');
            if (stepper && typeof stepper.setValue === 'function') stepper.setValue(quantity, false);
            else input.value = quantity;
          };
          if (source !== 'main') apply(this.qtyInput);
          if (source !== 'quick') apply(this.qbQtyInput);
          /* Personalization blocks show one message field per unit. */
          window.__sxPdpUnits = { sectionId: this.sectionId, quantity };
          document.dispatchEvent(new CustomEvent('sx:pdp-units', { detail: { sectionId: this.sectionId, quantity } }));
        }

        /* Shopify's accelerated checkout skips theme validation and may not carry personalization, so products
           with a personalization field use the theme's own "buy now" (add to cart, then checkout). */
        syncPaymentButton() {
          if (!this.payment) return;
          const personalized = this.personalizationCount() > 0;
          this.payment.hidden = personalized;
          if (this.buyNow) this.buyNow.hidden = !personalized;
        }

        setState(state) {
          this.state = state;
          const available = state === 'available';
          if (this.actions) this.actions.hidden = state === 'sold-out';
          if (this.soldOutPanel) this.soldOutPanel.hidden = state !== 'sold-out';
          if (this.atc) this.atc.disabled = !available;
          if (this.buyNow) this.buyNow.disabled = !available;
          if (this.qbAtc && !this.qbAtc.getAttribute('aria-busy')) {
            this.qbAtc.disabled = !available;
            this.qbAtc.innerHTML = available ? this.qbAddHtml : `<span>${this.escape(this.qbAtc.dataset.labelSoldout)}</span>`;
          }
          if (this.qbQty) this.qbQty.hidden = !available;
          this.setError('');
          this.updateStickyVisibility();
        }

        escape(text) {
          const span = document.createElement('span');
          span.textContent = text || '';
          return span.innerHTML;
        }

        setError(message) {
          [this.errorEl, this.qbError].forEach((el) => {
            if (!el) return;
            el.textContent = '';
            el.hidden = true;
            el.removeAttribute('role');
          });
          if (!message) return;
          const target = this.modal?.dialog?.open ? this.qbError : this.errorEl;
          if (!target) return;
          target.textContent = message;
          target.hidden = false;
          target.setAttribute('role', 'alert');
        }

        setBusy(button, busy) {
          if (!button) return;
          if (busy) {
            button.dataset.idleHtml = button.innerHTML;
            button.setAttribute('aria-busy', 'true');
            button.disabled = true;
            button.innerHTML = `<span class="sx-spinner" aria-hidden="true"></span><span>${this.escape(this.dataset.addingText)}</span>`;
          } else {
            button.removeAttribute('aria-busy');
            if (button.dataset.idleHtml) button.innerHTML = button.dataset.idleHtml;
            button.disabled = button === this.stickyBtn ? false : this.state !== 'available';
          }
        }

        async add(intent, button) {
          if (this.busy) return false;
          const theme = window.SxTheme;
          const pdp = window.SxPdp;
          this.setError('');
          if (pdp && !pdp.validate(this.sectionId)) return false;

          const id = Number(this.form?.querySelector('input[name="id"]')?.value);
          if (!id || this.state !== 'available' || !theme?.cart) {
            this.setError(this.dataset.unavailableText);
            return false;
          }

          this.busy = true;
          this.setBusy(button, true);
          try {
            const items = pdp ? pdp.lineItems(this.sectionId, id, this.quantity) : [{ id, quantity: this.quantity }];
            await theme.cart.add(items);
            if (intent === 'checkout') {
              window.location.href = `${String(theme.routes?.root || '/').replace(/\/?$/, '/')}checkout`;
              return true;
            }
            pdp?.reset(this.sectionId);
            if (this.modal?.dialog?.open) this.modal.close();
            theme.cart.afterAdd();
            return true;
          } catch (error) {
            this.setError(error?.message || this.dataset.errorText);
            return false;
          } finally {
            this.busy = false;
            this.setBusy(button, false);
          }
        }

        /* ---------- Sticky bar ---------- */
        setupSticky() {
          if (!this.sticky) return;
          this.stickyBtn = this.sticky.querySelector('[data-sticky-btn]');
          this.stickyBtn?.addEventListener('click', () => {
            if (this.hasChoices && this.modal) this.openQuickBuy(this.stickyBtn);
            else this.add('cart', this.stickyBtn);
          });
          /* Portaled to <body> so the sticky info column's stacking context cannot trap it under later sections. */
          document.body.appendChild(this.sticky);
          if (!('IntersectionObserver' in window)) return;
          this.observer = new IntersectionObserver(([entry]) => {
            this.pastBuyBox = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.updateStickyVisibility();
          });
          this.observer.observe(this);
        }

        updateStickyVisibility() {
          if (!this.sticky) return;
          const purchasable = this.state === 'available' || (this.hasChoices && this.state === 'sold-out');
          const visible = !!this.pastBuyBox && purchasable;
          this.sticky.classList.toggle('is-visible', visible);
          this.sticky.setAttribute('aria-hidden', String(!visible));
          this.sticky.inert = !visible;
        }

        /* ---------- Quick buy dialog ---------- */
        setupQuickBuy() {
          if (!this.modal) return;
          /* Not "slot": that name is a built-in HTMLElement property and cannot hold an element. */
          this.qbSlot = this.modal.querySelector('[data-qb-slot]');
          this.qbAtc = this.modal.querySelector('[data-qb-atc]');
          this.qbAddHtml = this.modal.querySelector('[data-qb-add-template]')?.innerHTML || '';
          this.qbError = this.modal.querySelector('[data-qb-error]');
          this.qbQty = this.modal.querySelector('[data-qb-qty]');
          this.qbQtyInput = this.qbQty?.querySelector('input');
          this.placeholders = [];

          this.qbAtc?.addEventListener('click', () => this.add('cart', this.qbAtc));
          this.qbQtyInput?.addEventListener('change', () => this.syncQuantity(this.qbQtyInput.value, 'quick'));
          this.modal.querySelector('[data-qb-details]')?.addEventListener('click', () => {
            this.modal.close();
            setTimeout(() => {
              const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              this.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
              (this.atc && !this.atc.disabled ? this.atc : this.querySelector('button:not([disabled])'))?.focus({ preventScroll: true });
            }, 0);
          });
          this.modal.querySelector('dialog')?.addEventListener('close', () => {
            this.restorePortables();
            this.setError('');
          });
        }

        openQuickBuy(opener) {
          if (!this.modal || typeof this.modal.open !== 'function') return;
          this.syncQuantity(this.quantity, 'main');
          this.movePortables();
          this.modal.open(opener);
        }

        /* The page's own variant picker and personalization blocks move into the dialog while it is open,
           so selections, validation and form="" associations stay in one place. */
        movePortables() {
          if (!this.qbSlot) return;
          document.querySelectorAll(`[data-qb-portable][data-section-id="${this.sectionId}"]`).forEach((el) => {
            if (this.qbSlot.contains(el)) return;
            const placeholder = document.createElement('div');
            placeholder.className = 'sx-block';
            placeholder.style.height = `${el.offsetHeight}px`;
            placeholder.setAttribute('aria-hidden', 'true');
            el.replaceWith(placeholder);
            this.qbSlot.appendChild(el);
            this.placeholders.push({ el, placeholder });
          });
        }

        restorePortables() {
          this.placeholders.forEach(({ el, placeholder }) => {
            if (placeholder.isConnected) placeholder.replaceWith(el);
          });
          this.placeholders = [];
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-pdp-countdown')) {
    customElements.define(
      'sx-pdp-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.end = Date.parse(this.dataset.end || '');
          if (Number.isNaN(this.end)) return;
          this.units = {};
          this.querySelectorAll('[data-unit]').forEach((unit) => {
            this.units[unit.dataset.unit] = unit;
          });
          this.tick();
          this.timer = window.setInterval(() => this.tick(), 1000);
        }

        disconnectedCallback() {
          window.clearInterval(this.timer);
        }

        tick() {
          const diff = this.end - Date.now();
          if (diff <= 0) {
            window.clearInterval(this.timer);
            this.hidden = true;
            return;
          }
          const pad = (value) => String(value).padStart(2, '0');
          const values = {
            days: Math.floor(diff / 86400000),
            hours: Math.floor((diff % 86400000) / 3600000),
            minutes: Math.floor((diff % 3600000) / 60000),
            seconds: Math.floor((diff % 60000) / 1000),
          };
          Object.entries(values).forEach(([key, value]) => {
            const unit = this.units[key];
            if (!unit) return;
            unit.querySelector('.sx-countdown__value').textContent = pad(value);
            if (key === 'days') unit.hidden = value === 0;
          });
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-delivery-estimate')) {
    const DAY_MS = 86400000;
    const TICK_MS = 30000;
    const isWeekend = (date) => date.getDay() === 0 || date.getDay() === 6;

    const addBusinessDays = (start, days, skipWeekends) => {
      const date = new Date(start.getTime());
      let remaining = Math.max(0, Math.round(days));
      while (skipWeekends && isWeekend(date)) date.setTime(date.getTime() + DAY_MS);
      while (remaining > 0) {
        date.setTime(date.getTime() + DAY_MS);
        if (!skipWeekends || !isWeekend(date)) remaining -= 1;
      }
      return date;
    };

    const deliveryWindow = (now, rule) => {
      const base = now.getHours() < rule.cutoffHour ? now : addBusinessDays(now, 1, rule.skipWeekends);
      const dispatch = addBusinessDays(base, 0, rule.skipWeekends);
      return {
        dispatch,
        from: addBusinessDays(dispatch, rule.minDays, rule.skipWeekends),
        to: addBusinessDays(dispatch, Math.max(rule.maxDays, rule.minDays), rule.skipWeekends),
      };
    };

    const msUntilCutoff = (now, rule) => {
      if (rule.skipWeekends && isWeekend(now)) return null;
      const cutoff = new Date(now.getTime());
      cutoff.setHours(rule.cutoffHour, 0, 0, 0);
      const diff = cutoff.getTime() - now.getTime();
      return diff > 0 ? diff : null;
    };

    customElements.define(
      'sx-delivery-estimate',
      class extends HTMLElement {
        connectedCallback() {
          const d = this.dataset;
          this.rule = {
            minDays: Number(d.minDays || 1),
            maxDays: Number(d.maxDays || 3),
            cutoffHour: Number(d.cutoffHour || 14),
            skipWeekends: d.skipWeekends === 'true',
          };
          const locale = d.locale || document.documentElement.lang || 'tr';
          this.formatters = {
            long: new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', weekday: 'short' }),
            short: new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' }),
          };
          this.render();
          this.timer = window.setInterval(() => this.render(), TICK_MS);
        }

        disconnectedCallback() {
          window.clearInterval(this.timer);
        }

        fill(template, values) {
          return String(template || '').replace(/\[(\w+)\]/g, (match, key) => (key in values ? values[key] : match));
        }

        day(date, withWeekday = true) {
          return (withWeekday ? this.formatters.long : this.formatters.short).format(date);
        }

        render() {
          const d = this.dataset;
          const now = new Date();
          const { dispatch, from, to } = deliveryWindow(now, this.rule);
          const left = msUntilCutoff(now, this.rule);
          const hours = left ? Math.floor(left / 3600000) : 0;
          const minutes = left ? Math.floor((left % 3600000) / 60000) : 0;
          const time = hours > 0 ? `${hours} ${d.hoursLabel} ${minutes} ${d.minutesLabel}` : `${minutes} ${d.minutesLabel}`;
          const sameDay = from.getTime() === to.getTime();
          const estimate = sameDay
            ? this.fill(d.estimateText, { from: this.day(from), to: '' }).replace(/\s*[–-]\s*$/, '')
            : this.fill(d.estimateText, { from: this.day(from, false), to: this.day(to) });

          const lead = this.querySelector('[data-delivery-lead]');
          const strong = this.querySelector('[data-delivery-estimate]');
          if (lead) lead.textContent = left ? this.fill(d.cutoffText, { time }) : this.fill(d.dispatchText, { date: this.day(dispatch) });
          if (strong) strong.textContent = estimate;

          const steps = {
            ordered: this.day(now, false),
            shipped: this.day(dispatch, false),
            delivered: sameDay ? this.day(from, false) : `${this.day(from, false)} – ${this.day(to, false)}`,
          };
          this.querySelectorAll('[data-delivery-step]').forEach((el) => {
            el.textContent = steps[el.dataset.deliveryStep] || '';
          });
          this.classList.remove('pdp-delivery--placeholder');
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq-item"] && !Shopify.designMode) return;
  try {
    /* Theme editor: open the FAQ item whose block is selected in the sidebar. */
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target instanceof HTMLElement ? event.target.querySelector('details[data-faq-item]') : null;
    if (details) details.open = true;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["frequently-bought"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-fbt')) {
    const IMAGE_WIDTH = 200;
    const ADDED_MS = 2000;

    const imageUrl = (src) => {
      if (!src) return '';
      try {
        const url = new URL(src.startsWith('//') ? `https:${src}` : src, window.location.origin);
        url.searchParams.set('width', String(IMAGE_WIDTH));
        return url.toString();
      } catch (error) {
        return src;
      }
    };

    customElements.define(
      'sx-fbt',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.list = this.querySelector('[data-fbt-list]');
          this.template = this.querySelector('template[data-fbt-row]');
          this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-add]');
            if (button) this.add(button);
          });
          /* A merchant-picked list is already rendered server-side; only fall back to the
             Product Recommendations API when no list was chosen. */
          if (!this.hasAttribute('data-manual')) this.load();
        }

        async load() {
          if (!this.list || !this.template || !this.dataset.productId) return;
          const limit = Number(this.dataset.limit) || 3;
          const intents = this.dataset.intent === 'related' ? ['related'] : [this.dataset.intent, 'related'];
          let products = [];
          for (const intent of intents) {
            try {
              const params = new URLSearchParams({ product_id: this.dataset.productId, limit: String(limit + 2), intent });
              const response = await fetch(`${this.dataset.url}?${params.toString()}`, { headers: { Accept: 'application/json' } });
              if (!response.ok) throw new Error(`HTTP ${response.status}`);
              const data = await response.json();
              products = (data.products || []).filter((item) => item.available);
            } catch (error) {
              products = [];
            }
            if (products.length) break;
          }
          if (!this.isConnected || !products.length) return;
          this.list.replaceChildren(...products.slice(0, limit).map((item) => this.row(item)));
          this.hidden = false;
        }

        row(product) {
          const theme = window.SxTheme;
          const fragment = this.template.content.cloneNode(true);
          const row = fragment.querySelector('.pdp-fbt__row');
          row.querySelectorAll('[data-href]').forEach((link) => {
            link.href = product.url;
          });
          row.querySelector('[data-name]').textContent = product.title;
          const image = row.querySelector('img');
          const src = imageUrl(product.featured_image);
          if (src) image.src = src;
          else image.remove();
          const variant = (product.variants || []).find((item) => item.available) || (product.variants || [])[0];
          const price = variant ? variant.price : product.price;
          const compare = variant ? variant.compare_at_price : product.compare_at_price;
          row.querySelector('[data-final]').textContent = theme.formatMoney(price);
          if (compare && compare > price) {
            const compareEl = row.querySelector('[data-compare]');
            compareEl.textContent = theme.formatMoney(compare);
            compareEl.hidden = false;
            row.querySelector('[data-price]').classList.add('sx-price--sale');
          }
          const tag = (this.dataset.personalizationTag || '').trim().toLowerCase();
          const tags = (product.tags || []).map((item) => String(item).toLowerCase());
          const needsOptions = (product.variants || []).length > 1 || (tag && tags.includes(tag));
          if (needsOptions || !variant) {
            const choose = row.querySelector('[data-choose]');
            choose.href = product.url;
            choose.hidden = false;
          } else {
            const add = row.querySelector('[data-add]');
            add.dataset.variantId = String(variant.id);
            add.hidden = false;
          }
          return fragment;
        }

        async add(button) {
          const theme = window.SxTheme;
          const label = button.querySelector('[data-add-label]');
          const error = button.closest('.pdp-fbt__row').querySelector('[data-row-error]');
          const original = label ? label.textContent : '';
          button.setAttribute('aria-busy', 'true');
          button.disabled = true;
          if (error) error.hidden = true;
          try {
            await theme.cart.add([{ id: Number(button.dataset.variantId), quantity: 1 }]);
            /* Same confirmation as the main add-to-cart: the sheet rises over the product page. */
            theme.cart.afterAdd();
            if (!button.isConnected) return;
            button.classList.add('is-added');
            if (label && this.dataset.added) label.textContent = this.dataset.added;
            window.setTimeout(() => {
              if (!button.isConnected) return;
              button.classList.remove('is-added');
              if (label) label.textContent = original;
            }, ADDED_MS);
          } catch (failure) {
            if (!error || !button.isConnected) return;
            error.textContent = failure.data?.description || failure.data?.message || this.dataset.error;
            error.hidden = false;
          } finally {
            if (button.isConnected) {
              button.removeAttribute('aria-busy');
              button.disabled = false;
            }
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hero-slide"] && !Shopify.designMode) return;
  try {
    /* Decorative muted loop: plays only when the visitor has not asked for reduced motion. */
  if (!customElements.get('sx-ambient-video')) {
    customElements.define(
      'sx-ambient-video',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video');
          if (!this.video) return;
          this.query = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.sync = () => {
            if (this.query.matches) this.video.pause();
            else this.video.play().catch(() => undefined);
          };
          this.sync();
          this.query.addEventListener('change', this.sync);
        }

        disconnectedCallback() {
          this.query?.removeEventListener('change', this.sync);
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hotspot"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-hotspot')) {
    const MOBILE_QUERY = '(max-width: 749px)';

    customElements.define(
      'sx-hotspot',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-hotspot-toggle]');
          this.pop = this.querySelector('.hs__pop');
          if (!this.button || !this.pop) return;
          this.abort = new AbortController();
          const { signal } = this.abort;
          this.onDocumentPointer = this.onDocumentPointer.bind(this);
          this.onDocumentKey = this.onDocumentKey.bind(this);
          this.button.addEventListener('click', () => (this.isOpen ? this.close(false) : this.open()), { signal });
          this.addEventListener('shopify:block:select', () => this.open(false), { signal });
          this.addEventListener('shopify:block:deselect', () => this.close(false), { signal });
        }

        disconnectedCallback() {
          this.abort?.abort();
          this.close(false);
        }

        get isOpen() {
          return this.classList.contains('is-open');
        }

        open(moveFocus = true) {
          if (this.isOpen) return;
          if (window.matchMedia(MOBILE_QUERY).matches) this.mountSheet();
          this.pop.hidden = false;
          this.classList.add('is-open');
          this.button.setAttribute('aria-expanded', 'true');
          document.addEventListener('pointerdown', this.onDocumentPointer);
          document.addEventListener('keydown', this.onDocumentKey);
          if (moveFocus) this.pop.querySelector('a')?.focus({ preventScroll: true });
        }

        close(restoreFocus) {
          if (!this.isOpen) return;
          document.removeEventListener('pointerdown', this.onDocumentPointer);
          document.removeEventListener('keydown', this.onDocumentKey);
          this.classList.remove('is-open');
          this.button.setAttribute('aria-expanded', 'false');
          this.pop.hidden = true;
          this.unmountSheet();
          if (restoreFocus) this.button.focus();
        }

        /* Mobile: the card becomes a bottom sheet appended to <body> so no ancestor clips it. */
        mountSheet() {
          const scheme = this.closest('[data-color-scheme]')?.dataset.colorScheme;
          this.sheet = document.createElement('div');
          this.sheet.className = `sx-scheme hs-sheet${scheme ? ` color-${scheme}` : ''}`;
          const backdrop = document.createElement('div');
          backdrop.className = 'hs-sheet__backdrop';
          backdrop.setAttribute('aria-hidden', 'true');
          this.sheet.appendChild(backdrop);
          this.popClass = this.pop.className;
          this.pop.className = 'hs__pop hs__pop--sheet';
          this.sheet.appendChild(this.pop);
          document.body.appendChild(this.sheet);
        }

        unmountSheet() {
          if (!this.sheet) return;
          this.pop.className = this.popClass;
          this.appendChild(this.pop);
          this.sheet.remove();
          this.sheet = null;
        }

        onDocumentPointer(event) {
          if (this.contains(event.target) || this.pop.contains(event.target)) return;
          this.close(false);
        }

        onDocumentKey(event) {
          if (event.key === 'Escape') this.close(true);
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["media-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-media-card')) {
    customElements.define(
      'sx-media-card',
      class extends HTMLElement {
        connectedCallback() {
          this.video = this.querySelector('video[data-src]');
          if (!this.video || !('IntersectionObserver' in window)) return;
          this.hasPoster = !this.video.classList.contains('is-ready');
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.video.addEventListener('playing', () => this.video.classList.add('is-ready'));

          // Load only near the viewport; under reduced motion the poster stands in (video loads only without poster).
          this.nearObserver = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.nearObserver.disconnect();
              this.near = true;
              this.sync();
            },
            { rootMargin: '300px 0px' },
          );
          this.viewObserver = new IntersectionObserver(
            (entries) => {
              this.visible = entries[entries.length - 1].isIntersecting;
              this.sync();
            },
            { threshold: 0.4 },
          );
          this.nearObserver.observe(this);
          this.viewObserver.observe(this);
        }

        disconnectedCallback() {
          this.nearObserver?.disconnect();
          this.viewObserver?.disconnect();
        }

        sync() {
          const canAutoplay = !this.reduced.matches;
          const shouldLoad = this.near && (canAutoplay || !this.hasPoster);
          if (!shouldLoad) return;
          if (!this.video.getAttribute('src')) {
            this.video.preload = canAutoplay ? 'none' : 'metadata';
            this.video.src = this.video.dataset.src;
          }
          if (canAutoplay && this.visible) {
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["personalization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-personalization')) {
    const MORSE = {
      A: '.-', B: '-...', C: '-.-.', Ç: '-.-..', D: '-..', E: '.', F: '..-.', G: '--.', Ğ: '--.-.', H: '....',
      I: '..', İ: '.-..-', J: '.---', K: '-.-', L: '.-..', M: '--', N: '-.', O: '---', Ö: '---.', P: '.--.',
      Q: '--.-', R: '.-.', S: '...', Ş: '.--..', T: '-', U: '..-', Ü: '..--', V: '...-', W: '.--', X: '-..-',
      Y: '-.--', Z: '--..', 0: '-----', 1: '.----', 2: '..---', 3: '...--', 4: '....-', 5: '.....',
      6: '-....', 7: '--...', 8: '---..', 9: '----.',
    };
    const DISALLOWED = /[^A-Z0-9ÇĞİÖŞÜ ]/g;

    const metalOf = (variant) => {
      const text = (variant?.options || [variant?.title || ''])
        .join(' ')
        .toLocaleLowerCase('tr-TR')
        .replace(/ı/g, 'i')
        .replace(/ü/g, 'u')
        .replace(/ş/g, 's');
      if (text.includes('rose')) return 'rose';
      if (text.includes('gumus') || text.includes('silver')) return 'gumus';
      return 'altin';
    };

    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    customElements.define(
      'sx-personalization',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.unitsWrap = this.querySelector('[data-perso-units]');
          this.firstUnit = this.querySelector('[data-perso-field]');
          this.input = this.querySelector('[data-perso-input]');
          if (!this.input || !this.unitsWrap) return;
          this.baseLabel = this.firstUnit.querySelector('[data-perso-label]')?.textContent || '';
          this.hint = this.querySelector('[data-perso-hint]');
          this.hintText = this.hint?.textContent || '';
          this.codeInput = this.querySelector('[data-perso-code-input]');
          this.preview = this.querySelector('.pdp-morse');
          this.chain = this.querySelector('[data-morse-chain]');
          this.empty = this.querySelector('[data-morse-empty]');
          this.code = this.querySelector('[data-morse-code]');
          this.previewUnit = this.querySelector('[data-morse-unit]');
          this.second = this.querySelector('[data-perso-second-input]');
          this.secondField = this.querySelector('[data-perso-second]');
          this.secondError = this.querySelector('[data-perso-second-error]');
          this.max = Number(this.input.dataset.max || 20);
          this.template = this.firstUnit.cloneNode(true);
          this.activeIndex = 0;

          this.bindUnit(this.firstUnit);
          this.second?.addEventListener('input', () => this.setError(this.secondField, this.secondError, ''));

          this.onVariant = (event) => {
            const detail = event.detail || {};
            if (detail.sectionId === this.dataset.sectionId && detail.variant && this.preview) {
              this.preview.dataset.metal = metalOf(detail.variant);
            }
          };
          this.onUnits = (event) => {
            const detail = event.detail || {};
            if (detail.sectionId === this.dataset.sectionId) this.setUnits(detail.quantity);
          };
          document.addEventListener(window.SxTheme?.events?.variantChanged || 'sx:variant-changed', this.onVariant);
          document.addEventListener('sx:pdp-units', this.onUnits);

          const published = window.__sxPdpUnits;
          if (published && published.sectionId === this.dataset.sectionId) this.setUnits(published.quantity);
          this.renderPreview();
        }

        disconnectedCallback() {
          /* Moving the block into the quick-buy drawer re-connects it; listeners stay bound through the move. */
          if (this.isConnected) return;
        }

        get perUnit() {
          return this.dataset.perUnit === 'true';
        }

        units() {
          return Array.from(this.unitsWrap.querySelectorAll('[data-perso-field]'));
        }

        inputs() {
          return this.units().map((unit) => unit.querySelector('[data-perso-input]'));
        }

        unitLabel(index) {
          return (this.dataset.unitLabel || '[index].').replace('[index]', String(index + 1));
        }

        bindUnit(unit) {
          const input = unit.querySelector('[data-perso-input]');
          if (!input || input.dataset.bound) return;
          input.dataset.bound = 'true';
          let composing = false;
          const activate = () => {
            this.activeIndex = this.units().indexOf(unit);
            this.renderPreview();
          };
          input.addEventListener('compositionstart', () => (composing = true));
          input.addEventListener('compositionend', () => {
            composing = false;
            this.onInput(unit);
          });
          input.addEventListener('input', () => !composing && this.onInput(unit));
          input.addEventListener('focus', activate);
        }

        /* Shows one message field per unit (quantity or quantity-break card), keeping typed values. */
        setUnits(quantity) {
          const wanted = this.perUnit ? Math.max(1, Math.min(Number(quantity) || 1, Number(this.dataset.maxUnits) || 5)) : 1;
          const units = this.units();
          for (let i = units.length; i < wanted; i += 1) {
            const unit = this.template.cloneNode(true);
            const input = unit.querySelector('[data-perso-input]');
            const baseId = this.firstUnit.querySelector('[data-perso-input]').id;
            unit.dataset.unitIndex = String(i + 1);
            input.id = `${baseId}-u${i + 1}`;
            input.removeAttribute('name');
            input.removeAttribute('form');
            input.value = '';
            delete input.dataset.bound;
            unit.querySelector('label')?.setAttribute('for', input.id);
            const error = unit.querySelector('[data-perso-error]');
            if (error) {
              error.id = `${input.id}-error`;
              error.hidden = true;
              error.textContent = '';
            }
            input.setAttribute('aria-describedby', `${this.hint?.id || ''} ${input.id}-error`.trim());
            unit.classList.remove('is-invalid', 'is-active');
            this.unitsWrap.appendChild(unit);
            this.bindUnit(unit);
            this.renderCount(unit);
          }
          units.slice(wanted).forEach((unit) => unit.remove());
          const multi = wanted > 1;
          this.units().forEach((unit, index) => {
            const label = unit.querySelector('[data-perso-label]');
            if (!label) return;
            label.replaceChildren();
            if (multi) {
              const tag = document.createElement('span');
              tag.className = 'pdp-perso__unit-tag';
              tag.textContent = this.unitLabel(index);
              label.appendChild(tag);
            }
            label.appendChild(document.createTextNode(this.baseLabel));
          });
          if (this.activeIndex >= wanted) this.activeIndex = 0;
          this.renderPreview();
        }

        sanitize(raw) {
          return raw.toLocaleUpperCase('tr-TR').replace(DISALLOWED, '').replace(/ {2,}/g, ' ').replace(/^ /, '');
        }

        onInput(unit) {
          const input = unit.querySelector('[data-perso-input]');
          const raw = input.value;
          const caret = input.selectionStart ?? raw.length;
          const upper = raw.toLocaleUpperCase('tr-TR');
          const clean = this.sanitize(raw).slice(0, this.max);
          const removedInvalid = upper.replace(DISALLOWED, '') !== upper;
          if (clean !== raw) {
            const before = this.sanitize(raw.slice(0, caret)).length;
            input.value = clean;
            try {
              input.setSelectionRange(before, before);
            } catch (error) {
              /* some input types do not support selection */
            }
          }
          if (removedInvalid) this.flashHint(this.dataset.invalidText);
          if (clean.trim()) this.setError(unit, unit.querySelector('[data-perso-error]'), '');
          this.activeIndex = this.units().indexOf(unit);
          this.renderCount(unit);
          this.renderPreview();
        }

        renderCount(unit) {
          const input = unit.querySelector('[data-perso-input]');
          const count = unit.querySelector('[data-perso-count]');
          if (count && input) count.textContent = `${input.value.length}/${this.max}`;
        }

        flashHint(text) {
          if (!this.hint || !text) return;
          this.hint.textContent = text;
          this.hint.classList.add('is-warning');
          clearTimeout(this.hintTimer);
          this.hintTimer = setTimeout(() => {
            this.hint.textContent = this.hintText;
            this.hint.classList.remove('is-warning');
          }, 3500);
        }

        toMorse(text) {
          return text
            .trim()
            .split(/ +/)
            .filter(Boolean)
            .map((word) => Array.from(word).map((char) => MORSE[char] || '').filter(Boolean).join(' '))
            .join(' / ');
        }

        renderPreview() {
          const units = this.units();
          units.forEach((unit, index) => unit.classList.toggle('is-active', units.length > 1 && index === this.activeIndex));
          const input = units[this.activeIndex]?.querySelector('[data-perso-input]') || this.input;
          const text = input.value.trim();
          const morse = this.toMorse(text);
          if (this.codeInput) this.codeInput.value = this.toMorse(this.input.value);
          if (this.previewUnit) this.previewUnit.textContent = units.length > 1 ? ` · ${this.unitLabel(this.activeIndex)}` : '';
          if (!this.chain) return;

          const fragment = document.createDocumentFragment();
          const words = text ? text.split(/ +/) : [];
          words.forEach((word, wordIndex) => {
            if (wordIndex > 0) {
              const gap = document.createElement('span');
              gap.className = 'pdp-morse__gap';
              const spacer = document.createElement('i');
              spacer.className = 'pdp-morse__spacer';
              gap.appendChild(spacer);
              fragment.appendChild(gap);
            }
            Array.from(word).forEach((char) => {
              const code = MORSE[char];
              if (!code) return;
              const letter = document.createElement('span');
              letter.className = 'pdp-morse__letter';
              const beads = document.createElement('span');
              beads.className = 'pdp-morse__beads';
              Array.from(code).forEach((signal) => {
                const bead = document.createElement('i');
                bead.className = `pdp-morse__bead pdp-morse__bead--${signal === '.' ? 'dot' : 'dash'}`;
                beads.appendChild(bead);
              });
              const label = document.createElement('span');
              label.className = 'pdp-morse__char';
              label.textContent = char;
              letter.append(beads, label);
              fragment.appendChild(letter);
            });
          });

          const key = `${this.activeIndex}:`;
          const previous = this.lastKey?.startsWith(key) ? this.lastKey.slice(key.length) : null;
          this.chain.replaceChildren(fragment);
          /* Only newly typed letters animate in; unchanged beads stay still. */
          if (previous !== null && text.startsWith(previous)) {
            const stable = Array.from(previous.replace(/ /g, '')).length;
            this.chain.querySelectorAll('.pdp-morse__letter').forEach((letter, index) => {
              if (index < stable) letter.querySelectorAll('.pdp-morse__bead').forEach((bead) => (bead.style.animation = 'none'));
            });
          }
          this.lastKey = `${key}${text}`;
          if (this.empty) this.empty.hidden = !!text;
          if (this.code) this.code.textContent = morse;
        }

        setError(field, errorEl, message) {
          if (!field || !errorEl) return;
          field.classList.toggle('is-invalid', !!message);
          errorEl.textContent = message;
          errorEl.hidden = !message;
          const input = field.querySelector('input');
          if (message) {
            input?.setAttribute('aria-invalid', 'true');
            errorEl.setAttribute('role', 'alert');
          } else {
            input?.removeAttribute('aria-invalid');
            errorEl.removeAttribute('role');
          }
        }

        /* Returns false and shows inline errors when a required field is empty; focuses the first invalid field. */
        validate(shouldFocus = true) {
          const message = this.dataset.requiredText || '';
          let firstInvalid = null;
          if (this.dataset.required === 'true') {
            this.units().forEach((unit) => {
              const input = unit.querySelector('[data-perso-input]');
              if (input && !input.value.trim()) {
                this.setError(unit, unit.querySelector('[data-perso-error]'), message);
                firstInvalid = firstInvalid || input;
              }
            });
          }
          if (this.second && this.dataset.secondRequired === 'true' && !this.second.value.trim()) {
            this.setError(this.secondField, this.secondError, message);
            firstInvalid = firstInvalid || this.second;
          }
          if (firstInvalid && shouldFocus) {
            firstInvalid.focus();
            firstInvalid.scrollIntoView({ block: 'center', behavior: reducedMotion() ? 'auto' : 'smooth' });
          }
          return !firstInvalid;
        }

        /* One entry per unit: { message, code }. Empty optional messages are kept as empty strings. */
        messages() {
          return this.inputs().map((input) => {
            const message = (input?.value || '').trim();
            return { message, code: this.toMorse(message) };
          });
        }

        /* Cart lines for the given variant/quantity: units with the same message share a line. */
        lineItems(variantId, quantity, baseProperties) {
          const property = this.dataset.property;
          const codeProperty = this.dataset.codeProperty;
          const units = this.messages();
          if (!this.perUnit || units.length <= 1 || !property) {
            return [{ id: variantId, quantity, properties: baseProperties }];
          }
          const shared = { ...baseProperties };
          delete shared[property];
          if (codeProperty) delete shared[codeProperty];
          const groups = new Map();
          units.forEach(({ message, code }, index) => {
            const key = message;
            const entry = groups.get(key) || { message, code, quantity: 0 };
            entry.quantity += 1;
            groups.set(key, entry);
            if (index === units.length - 1 && quantity > units.length) entry.quantity += quantity - units.length;
          });
          return Array.from(groups.values()).map(({ message, code, quantity: qty }) => {
            const properties = { ...shared };
            if (message) properties[property] = message;
            if (message && codeProperty) properties[codeProperty] = code;
            return { id: variantId, quantity: qty, properties };
          });
        }

        reset() {
          this.inputs().forEach((input) => {
            if (input) input.value = '';
          });
          if (this.second) this.second.value = '';
          this.units().forEach((unit) => {
            this.setError(unit, unit.querySelector('[data-perso-error]'), '');
            this.renderCount(unit);
          });
          this.setError(this.secondField, this.secondError, '');
          this.lastKey = '';
          this.activeIndex = 0;
          this.renderPreview();
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quantity-breaks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-quantity-breaks')) {
    customElements.define(
      'sx-quantity-breaks',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.cards = Array.from(this.querySelectorAll('[role="radio"]'));
          this.cards.forEach((card, index) => {
            card.addEventListener('click', () => this.select(index));
            card.addEventListener('keydown', (event) => this.onKeydown(event, index));
          });
          this.onVariant = (event) => {
            const detail = event.detail || {};
            if (detail.sectionId === this.dataset.sectionId && detail.variant) this.reprice(detail.variant.price);
          };
          document.addEventListener(window.SxTheme?.events?.variantChanged || 'sx:variant-changed', this.onVariant);
          const initial = Math.min(Number(this.dataset.preselect || 0), this.cards.length - 1);
          if (initial >= 0) this.select(initial, false);
        }

        disconnectedCallback() {
          document.removeEventListener(window.SxTheme?.events?.variantChanged || 'sx:variant-changed', this.onVariant);
          this.bound = false;
        }

        onKeydown(event, index) {
          const count = this.cards.length;
          let next = -1;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % count;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + count) % count;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = count - 1;
          if (next < 0) return;
          event.preventDefault();
          this.select(next);
          this.cards[next].focus();
        }

        select(index, focusable = true) {
          this.cards.forEach((card, i) => {
            const selected = i === index;
            card.classList.toggle('is-selected', selected);
            card.setAttribute('aria-checked', String(selected));
            card.tabIndex = selected ? 0 : -1;
          });
          const quantity = Number(this.cards[index]?.dataset.quantity || 0);
          if (!quantity) return;
          if (window.SxPdp) {
            window.SxPdp.publishQuantity(this.dataset.productId, quantity);
          } else {
            window.__sxPdpQuantity = { productId: String(this.dataset.productId), quantity };
            document.dispatchEvent(new CustomEvent('sx:pdp-quantity', { detail: { productId: String(this.dataset.productId), quantity } }));
          }
        }

        /* Totals follow the selected variant; the percent is display-only and mirrors an admin automatic discount. */
        reprice(unitCents) {
          const format = (cents) => (window.SxTheme?.formatMoney ? window.SxTheme.formatMoney(cents) : String(cents / 100));
          const unitText = this.dataset.unitText || '';
          this.cards.forEach((card) => {
            const quantity = Number(card.dataset.quantity);
            const percent = Number(card.dataset.percent || 0);
            const full = unitCents * quantity;
            const total = Math.round((full * (100 - percent)) / 100);
            const unit = Math.round(total / quantity);
            const unitEl = card.querySelector('[data-qb-unit]');
            const totalEl = card.querySelector('[data-qb-total]');
            const compareEl = card.querySelector('[data-qb-compare]');
            if (unitEl) unitEl.textContent = unitText.replace('[price]', format(unit));
            if (totalEl) totalEl.textContent = format(total);
            if (compareEl) compareEl.textContent = format(full);
          });
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["result-stat"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-result-stat')) {
    customElements.define(
      'sx-result-stat',
      class extends HTMLElement {
        /* Counts 0 → target once scrolled into view. Server output shows the final value;
           only stats starting below the fold are reset, so nothing flashes above the fold. */
        connectedCallback() {
          this.target = Number(this.dataset.target) || 0;
          this.bar = this.querySelector('[data-rst-bar]');
          this.valueEl = this.querySelector('[data-rst-value]');
          if (!this.bar || !this.valueEl || !('IntersectionObserver' in window)) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          if (this.getBoundingClientRect().top <= window.innerHeight) return;

          this.render(0);
          this.observer = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.observer.disconnect();
              this.run();
            },
            { rootMargin: '0px 0px -10% 0px' },
          );
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          cancelAnimationFrame(this.frame);
        }

        render(value) {
          this.valueEl.textContent = String(value);
          this.bar.style.strokeDashoffset = String(100 - value);
        }

        run() {
          const duration = 1400;
          const start = performance.now();
          const ease = (t) => 1 - Math.pow(1 - t, 3);
          const tick = (now) => {
            const t = Math.min(1, (now - start) / duration);
            this.render(Math.round(this.target * ease(t)));
            if (t < 1) this.frame = requestAnimationFrame(tick);
          };
          this.frame = requestAnimationFrame(tick);
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ugc-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-ugc-video')) {
    customElements.define(
      'sx-ugc-video',
      class extends HTMLElement {
        connectedCallback() {
          this.media = this.querySelector('.ugc-card__media');
          this.video = this.querySelector('video[data-src]');
          if (!this.media) return;
          this.media.addEventListener('click', () => this.open());
          if (!this.video || !('IntersectionObserver' in window)) return;

          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
          this.hovered = false;
          this.inView = false;
          this.near = false;

          const setHover = (value) => {
            this.hovered = value;
            this.sync();
          };
          this.media.addEventListener('pointerenter', () => setHover(true));
          this.media.addEventListener('pointerleave', () => setHover(false));
          this.media.addEventListener('focus', () => setHover(true));
          this.media.addEventListener('blur', () => setHover(false));
          this.video.addEventListener('playing', () => this.media.classList.add('is-playing'));
          this.video.addEventListener('pause', () => this.media.classList.remove('is-playing'));

          this.nearObserver = new IntersectionObserver(
            (entries) => {
              if (!entries.some((entry) => entry.isIntersecting)) return;
              this.nearObserver.disconnect();
              this.near = true;
              this.video.src = this.video.dataset.src;
              this.sync();
            },
            { rootMargin: '200px 200px' },
          );
          this.viewObserver = new IntersectionObserver(
            (entries) => {
              this.inView = entries[entries.length - 1].isIntersecting;
              this.sync();
            },
            { threshold: 0.7 },
          );
          this.nearObserver.observe(this.media);
          this.viewObserver.observe(this.media);
        }

        disconnectedCallback() {
          this.nearObserver?.disconnect();
          this.viewObserver?.disconnect();
        }

        sync() {
          if (!this.video) return;
          // Silent preview: on hover (desktop) or while mostly in view (touch); never with reduced motion.
          const previewing = this.near && !this.reduced.matches && (this.canHover.matches ? this.hovered : this.inView);
          if (previewing) this.video.play().catch(() => {});
          else this.video.pause();
        }

        open() {
          const src = this.media.dataset.videoSrc;
          if (!src) return;
          this.video?.pause();
          this.dispatchEvent(
            new CustomEvent('sx:ugc-open', {
              bubbles: true,
              cancelable: true,
              detail: {
                videoSrc: src,
                posterSrc: this.media.dataset.poster,
                caption: this.media.dataset.caption,
                productTemplate: this.querySelector('template[data-story-product]'),
                opener: this.media,
              },
            }),
          );
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sx-variant-picker')) {
    customElements.define(
      'sx-variant-picker',
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.addEventListener('click', (event) => {
            const option = event.target.closest('[role="radio"][data-option-value-id]');
            if (option && this.contains(option)) this.choose(option);
          });
          this.addEventListener('keydown', (event) => this.onKeydown(event));
          this.addEventListener('change', (event) => {
            const select = event.target.closest('[data-option-select]');
            if (!select) return;
            const option = select.options[select.selectedIndex];
            if (option) this.choose(option);
          });
        }

        onKeydown(event) {
          const radio = event.target.closest('[role="radio"]');
          if (!radio) return;
          const group = radio.closest('[role="radiogroup"]');
          const radios = Array.from(group.querySelectorAll('[role="radio"]'));
          const index = radios.indexOf(radio);
          let next = -1;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % radios.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + radios.length) % radios.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = radios.length - 1;
          if (next < 0) return;
          event.preventDefault();
          radios[next].focus();
          this.choose(radios[next]);
        }

        /* Optimistic selection, then the section is re-rendered for the new variant. */
        markSelected(option) {
          const group = option.closest('[role="radiogroup"]');
          if (!group) return;
          group.querySelectorAll('[role="radio"]').forEach((radio) => {
            const selected = radio === option;
            radio.setAttribute('aria-checked', String(selected));
            radio.tabIndex = selected ? 0 : -1;
            radio.classList.toggle('is-selected', selected);
          });
        }

        selectedValueIds() {
          return Array.from(this.querySelectorAll('[data-option-group]')).map((group) => {
            const select = group.querySelector('[data-option-select]');
            if (select) return select.value;
            return group.querySelector('[role="radio"][aria-checked="true"]')?.dataset.optionValueId;
          }).filter(Boolean);
        }

        async choose(option) {
          if (option.getAttribute('aria-checked') === 'true') return;
          this.markSelected(option);
          const pdp = window.SxPdp;
          if (!pdp) return;
          this.classList.add('is-loading');
          try {
            await pdp.changeVariant({
              sectionId: this.dataset.sectionId,
              productUrl: this.dataset.productUrl,
              variantId: option.dataset.variantId || null,
              optionValueIds: this.selectedValueIds(),
            });
          } finally {
            this.classList.remove('is-loading');
          }
        }
      },
    );
  }
  } catch(e) { console.error(e); }
})();

})();
